/**************************************************
 * Nombre:       Formulario_Deposito_Ver
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AccountBalance, AccountCircleOutlined, FlagOutlined, MoneyOutlined} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSDEPOSITOS} from "../../Constantes";
import Zoom from "react-medium-image-zoom";
import 'react-medium-image-zoom/dist/styles.css'

const Formulario_Deposito_Ver = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSDEPOSITOS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AccountBalance} nombre={'Metodo'} dato={'metodo'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor en USD'} dato={'valor'} {...props}
                                   editable={false}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre Usuario'}
                                  dato={'nombreUsuario'} {...props}
                                  editable={false}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Mensaje'} dato={'mensaje'} {...props}
                    />
                </Grid>

                {props.props.getValues('img') &&
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', px: 2}}>
                        <Zoom>
                            <img src={props.props.getValues('img')} width={'auto'} height={250}/>
                        </Zoom>
                    </Grid>
                }

            </Grid>

        </form>

    )

}
export default Formulario_Deposito_Ver